import { defineRealtimeEvent, defineRealtimePresence } from 'services';
import type { PlanDiffResponse } from '../plan/diff';

export const blockInvalidate = defineRealtimeEvent<Record<string, never>>('BLOCK/INVALIDATE');
export const planPatch = defineRealtimeEvent<PlanDiffResponse>('PLAN/PATCH');

export type PlanPresenceData = {
  rowKey: string;
  columnKey: string;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** Accept both the old flat document and the new named `plan` slice during migration. */
function decodePlanPresence(value: unknown): PlanPresenceData | null {
  if (!isRecord(value)) return null;
  const candidate = isRecord(value.plan) ? value.plan : value;
  if (typeof candidate.rowKey !== 'string' || typeof candidate.columnKey !== 'string') return null;
  return { rowKey: candidate.rowKey, columnKey: candidate.columnKey };
}

export const planPresence = defineRealtimePresence<PlanPresenceData>('plan', decodePlanPresence, {
  // Keep markers visible to clients that still read the old flat presence document.
  legacyProjection: (value) => value,
});
